// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-05T04:20:19.085Z
// Property: The Maverick (ID: 6767906449164263)
// Collections: 52 amenities, 38 floorplans (live), 16 photos, 39 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162415",
  "multihub_property_id": "6767906449164263",
  "property_external_id": "725044",
  "property_zillow_url": "https://www.zillow.com/apartments/burien-wa/the-maverick/CjkdWS/",
  "property_apartments_url": "https://www.apartments.com/the-maverick-seattle-wa/1frb4t4/",
  "property_google_business_url": "https://www.google.com/maps?cid=16841344671586608040",
  "property_linkedin_url": null,
  "property_hubspot_id": "40201552159",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-maverick",
  "property_name": "The Maverick",
  "property_website_url": "https://www.themaverickburien.com",
  "property_domain": "https://www.themaverickburien.com/",
  "property_address": "15045 5th Ave SW",
  "property_full_address": "15045 5th Ave SW, Burien, WA 98166",
  "property_address_1": "15045 5th Ave SW",
  "property_address_2": null,
  "property_address_city": "Burien",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98166",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "University District",
  "property_address_latitude": "47.468408",
  "property_address_longitude": "-122.341243",
  "property_email": "info@themaverickburien.com",
  "property_phone": "(206) 241-4842",
  "property_call_tracking_phone": "833-487-1366",
  "property_company_name": "Pillar Properties",
  "property_company_url": "https://www.pillarproperties.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At The Maverick in Burien, WA, modern living meets serene comfort. Choose from stylish studios, one, or two-bedroom apartments with stunning mountain views and upscale amenities like a yoga studio, movie theater, and outdoor grill area. Uncover your perfect space today—explore our available units or schedule a tour!",
  "property_long_description": "Close to everything - our beautiful oversized, newly built apartments and townhomes in Burien, Washington, feature large studio, one, and two bedroom floor plans within walking distance of downtown Burien.Gorgeous views of Mt. Rainier are part of the package that includes quartz countertops, plank flooring, big walk-in closets, a kitchen pantry, in home washer and dryers, plus tons of indoor and outdoor amenity spaces. We are located one block from the Transit Center, a short distance from Seattle-Tacoma International Airport and less than 20 minutes south of Seattle for a quick and easy commute.\\\"Small Town USA\\\" NeighborhoodThe Maverick offers brand new large apartments and townhomes with a rental rate you won't find in the downtown core.Our location offers easy access - just a block away from Burien Transit Center where you can zip into Seattle in under 20 minutes and we're close to the airport and West Seattle too.  The weekly Farmer's Market is right outside our door and The Maverick is a short walk to Burien's urban core with a variety of local bakeries, grocers, delis, shops, and eateries.Enjoy the perfect line-up of amenities - work out in the 24-hour fitness center or visit the clubroom with a large-screen TV, fireplace and a full kitchen that's perfect for hosting parties and events. We also offer an outdoor grill and BBQ deck complete with a bocce ball court ideal for summer gatherings.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
    "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
    "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
    "width": 2000,
    "height": 1545
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "229",
  "property_year_built": "1963",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.01310043668121",
  "property_admin_fee": "400",
  "property_application_fee": "50",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "45",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "180",
  "property_pet_restrictions": "Restrictions: No Aggressive Breeds.\nBreed and weight restrictions apply.\n2 pet max.",
  "property_pet_policy_description": "We are a Pet Friendly Community and allow 2 pets and no weight limit.  Pet Fee is $350.00 per pet and one time Pet Deposit is $300.00 with $45.00 per pet Pet Rent.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://maverickapartments.securecafe.com/onlineleasing/the-maverick-0/floorplans.aspx",
  "property_resident_portal_url": "https://maverickapartments.securecafenet.com/residentservices/the-maverick-0/userlogin",
  "property_apply_now_url": "https://maverickapartments.securecafe.com/onlineleasing/the-maverick-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d2fdb-f40a-769c-9880-2921d887ea91.webp",
  "property_primary_logo_media": {
    "alt_text": "The Maverick logo",
    "public_id": "019d2fdb-f40a-769c-9880-2921d887ea91",
    "storage_key": "property/6767906449164263/019d2fdb-f40a-769c-9880-2921d887ea91.webp",
    "width": 432,
    "height": 288
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d2fdc-1540-707f-9f97-a40b20cb8838.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Maverick logo with a circular emblem and text.",
    "public_id": "019d2fdc-1540-707f-9f97-a40b20cb8838",
    "storage_key": "property/6767906449164263/019d2fdc-1540-707f-9f97-a40b20cb8838.webp",
    "width": 432,
    "height": 288
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d2fdc-094e-7772-b991-fa856e914d78.webp",
  "property_icon_media": {
    "alt_text": "Red logo with the letter M inside a circle.",
    "public_id": "019d2fdc-094e-7772-b991-fa856e914d78",
    "storage_key": "property/6767906449164263/019d2fdc-094e-7772-b991-fa856e914d78.webp",
    "width": 598,
    "height": 598
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d2fdc-094e-7772-b991-fa856e914d78.webp",
  "property_fav_icon_media": {
    "alt_text": "Red logo with the letter M inside a circle.",
    "public_id": "019d2fdc-094e-7772-b991-fa856e914d78",
    "storage_key": "property/6767906449164263/019d2fdc-094e-7772-b991-fa856e914d78.webp",
    "width": 598,
    "height": 598
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d2fdb-eb8c-7078-a47e-0648c526f352.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Maverick logo with a stylized M in a circle above the property name.",
    "public_id": "019d2fdb-eb8c-7078-a47e-0648c526f352",
    "storage_key": "property/6767906449164263/019d2fdb-eb8c-7078-a47e-0648c526f352.webp",
    "width": 560,
    "height": 163
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d2fdb-f63b-7240-9781-a992b66c9041.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Maverick logo.",
    "public_id": "019d2fdb-f63b-7240-9781-a992b66c9041",
    "storage_key": "property/6767906449164263/019d2fdb-f63b-7240-9781-a992b66c9041.webp",
    "width": 432,
    "height": 288
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d06cf-26f9-7551-948c-1245b11c8422.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc2-1eb8-7554-8d89-d3424651cf63.webp",
  "property_company_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc2-1eb8-7554-8d89-d3424651cf63",
    "storage_key": "company/5767906449162415/019d2fc2-1eb8-7554-8d89-d3424651cf63.webp",
    "width": 189,
    "height": 128
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc1-9029-7028-b531-c3ae9dacde22.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc1-9029-7028-b531-c3ae9dacde22",
    "storage_key": "company/5767906449162415/019d2fc1-9029-7028-b531-c3ae9dacde22.webp",
    "width": 178,
    "height": 122
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc1-00d2-7093-a184-b3de0f0bba5a.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc1-00d2-7093-a184-b3de0f0bba5a",
    "storage_key": "company/5767906449162415/019d2fc1-00d2-7093-a184-b3de0f0bba5a.webp",
    "width": 178,
    "height": 122
  },
  "property_primary_color": "#A02816",
  "property_secondary_color": "#58595b",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#000000",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "593 - 1112",
  "property_sqft_min": "593",
  "property_sqft_max": "1112",
  "property_price_range": "1830 - 3799",
  "property_price_min": "1830",
  "property_price_max": "3799",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/themaverickburien/",
  "property_instagram_url": "https://www.instagram.com/themaverickburien",
  "property_twitter_url": "https://x.com/TheMaverickApts",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJX1MV3ZxEkFQRqGPW4b95uOk",
  "property_youtube_url": "https://www.youtube.com/channel/UC5lrzmK4okgLogp-B3TvhFA",
  "property_yelp_url": "https://www.yelp.com/biz/the-maverick-burien-3",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Maverick",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "Welcome to The Maverick in Burien, WA, where modern living meets vibrant community life. Choose from stylish studios to spacious two-bedroom apartments adorned with quartz countertops and stunning mountain views. Enjoy amenities like a yoga studio, movie theater, and outdoor BBQ area—all designed for your comfort and convenience.",
  "property_home_floorplans_blurb": "Elevate your lifestyle at The Maverick in Burien, WA, where modern design meets comfort. Whether you're drawn to our chic studio, cozy one-bedroom, or spacious two-bedroom layouts, each space is crafted for your unique needs. Browse our available apartment homes to find the perfect floor plan that suits you!",
  "property_home_gallery_blurb": "At The Maverick in Burien, WA, stylish living meets exceptional amenities. Enjoy spacious floor plans from studios to lofted townhomes, complete with stunning mountain views. Unwind at our yoga studio or outdoor grill area, and embrace a vibrant lifestyle with on-site movie theater and clubroom. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Discover your ideal home at The Maverick in Burien, where we offer stunning one-bedroom, two-bedroom, and studio floor plans. Explore our vibrant neighborhood filled with local favorites and nearby attractions. See what's around our community and embrace the lifestyle you deserve!",
  "property_home_reviews_blurb": "At The Maverick in Burien, WA, residents rave about our welcoming community and dedicated staff. One satisfied resident shared, \"The staff is super friendly and quick to respond,\" making everyday living a breeze. With exceptional amenities and a prime location, you’ll love calling The Maverick home!",
  "property_neighborhood_blurb": "Nestled in Burien, WA, The Maverick offers vibrant living next to thrilling attractions like The Museum of Flight and K1 Speed for adrenaline seekers. Whether you’re visiting local favorites or enjoying outdoor escapes like Lincoln Park and Kubota Garden, our community puts excitement at your doorstep. Explore your new neighborhood today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Maverick in Burien, WA, enjoy a lifestyle enriched by stunning mountain views and resort-style amenities. From our state-of-the-art yoga studio to a charming outdoor grill area and a cozy movie theater, every detail is crafted for comfort and convenience. Elevate your living experience today!",
  "property_applynow_blurb": "At The Maverick in Burien, WA, experience contemporary living in thoughtfully designed floor plans — from cozy studios to spacious lofted townhomes. Enjoy exceptional amenities like a yoga studio, outdoor grill area, and a movie theater, all complemented by breathtaking mountain views. Rent online today and elevate your lifestyle!",
  "property_contactus_blurb": "At The Maverick in Burien, WA, our diverse floor plans—ranging from cozy studios to spacious one and two-bedroom apartments—cater to every lifestyle. Embrace modern living in our vibrant community. Have questions? Contact our leasing team today for personalized assistance! Your new home awaits!",
  "property_faqs_blurb": "At The Maverick in Burien, WA, we cater to diverse lifestyles with thoughtfully designed one-bedroom, two-bedroom, and studio floor plans. Curious about what makes our community stand out? Navigate to our FAQs page for insightful answers and a glimpse into life at The Maverick, where comfort meets convenience.",
  "property_floorplans_blurb": "At The Maverick in Burien, WA, our thoughtfully designed floor plans cater to every lifestyle. Choose from cozy studios, comfortable one-bedroom, or spacious two-bedroom apartments, each tailored for modern living. Browse our available homes to find the perfect layout that suits your unique style and needs!",
  "property_gallery_blurb": "At The Maverick in Burien, WA, imagine vibrant living framed by stunning mountain views. With flexible floor plans like spacious lofted townhomes and modern amenities—from a yoga studio to a cozy movie theater—your perfect home awaits. Picture yourself enjoying the outdoor grill area or relaxing in the stylish clubroom!",
  "property_interactivemap_blurb": "At The Maverick in Burien, WA, comfort meets style in our thoughtfully designed one-bedroom, two-bedroom, and studio apartments. Enjoy stunning mountain views, a state-of-the-art yoga studio, and a vibrant clubroom with a fireplace. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At The Maverick in Burien, WA, your pet is more than just a companion; they're part of the family. Our vibrant community is designed for pet lovers, offering ample green spaces and a welcoming atmosphere. Experience modern living where your furry friend can thrive alongside you!",
  "property_referafriend_blurb": "At The Maverick in Burien, WA, cozy living awaits! Choose from stylish studio, one, or two-bedroom floor plans tailored for comfort. Great friends make great neighbors—refer a friend today and help build our vibrant community. Living here isn’t just about space; it’s about connections!",
  "property_residentaccess_blurb": "Welcome to The Maverick in Burien, WA, where every floor plan—be it our cozy studios, spacious one-bedroom, or family-friendly two-bedroom apartments—offers a unique living experience. Log in to your resident portal to easily manage rent, maintenance requests, and more, ensuring you enjoy every moment in your new home.",
  "property_reviews_blurb": "At The Maverick in Burien, residents rave about the community spirit and dedicated staff. Enjoy the convenience of timely maintenance and engaging events hosted by friendly team members. With countless amenities at your fingertips, it’s no wonder living here feels like home. “Living here has been such a great experience!”",
  "property_created_at": "1743797426055",
  "property_scheduletour_blurb": "At The Maverick in Burien, WA, our thoughtfully designed floor plans—a cozy studio, a spacious one-bedroom, or a luxurious two-bedroom—invite you to truly feel at home. Schedule a tour today and find out why our residents rave about life in our vibrant community!",
  "property_thankyou_blurb": "Thank you for reaching out to The Maverick in Burien, WA! Soon, you'll discover our thoughtfully designed floor plans, including cozy studios and spacious one- and two-bedroom apartments. Get ready to embrace a vibrant community that's just a text away. Stay tuned for your personalized response!",
  "property_virtualtours_blurb": "At The Maverick in Burien, WA, your ideal living space awaits! Choose from stylish studio, one-bedroom, or two-bedroom floor plans designed for comfort and flexibility. Immerse yourself in our vibrant community—take a virtual tour today and envision your future home among modern amenities and welcoming spaces.",
  "property_copyright": "2026 All Rights Reserved. The Maverick",
  "property_seo_title_home": "Home | Apartments for Rent Near Seattle",
  "property_seo_description_home": "Find your perfect space at The Maverick in Burien, WA—studio, 1, and 2 bedroom apartments just a short distance from Seattle and SeaTac.",
  "property_seo_title_floorplans": "Floor Plans | Townhomes Near Seattle WA",
  "property_seo_description_floorplans": "Explore studio, 1, and 2 bedroom floor plans at The Maverick. Stylish homes and townhomes near Seattle, SeaTac, and Tacoma available now.",
  "property_seo_title_amenities": "Amenities | Burien WA Apartments For Rent",
  "property_seo_description_amenities": "The Maverick offers modern amenities and comfort in Burien, WA. Discover pet-friendly apartments near Seattle with upscale features.",
  "property_seo_title_gallery": "Gallery | Homes For Rent Near Seattle, WA",
  "property_seo_description_gallery": "Browse The Maverick’s photo gallery to see stylish interiors, spacious layouts, and beautiful homes near Mount Rainier and Seattle.",
  "property_seo_title_virtualtours": "Virtual Tours | Townhomes Near SeaTac",
  "property_seo_description_virtualtours": "Take a virtual tour of The Maverick’s townhomes and apartments near SeaTac and Seattle—explore modern living from the comfort of home.",
  "property_seo_title_interactivemap": "Interactive Map | Townhomes Near Seattle WA",
  "property_seo_description_interactivemap": "Use our interactive map to explore The Maverick’s layout and find available apartments or townhomes near Seattle, SeaTac, and Tacoma.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments for Rent Near SeaTac",
  "property_seo_description_neighborhood": "Live near Seattle and surrounding cities like Tacoma and SeaTac. The Maverick’s Burien location puts shops, restaurants, and more just minutes from your door.",
  "property_seo_title_contact": "Contact Us | Apartments for Rent Near Tacoma WA",
  "property_seo_description_contact": "Have questions about living at The Maverick in Burien, WA? Contact us to learn more about our apartments near Tacoma and SeaTac.",
  "property_seo_title_faqs": "FAQ | Apartments for Rent Near SeaTac",
  "property_seo_description_faqs": "Get answers about leasing, pets, parking, and more. Everything you need to know about The Maverick’s homes in Burien WA.",
  "property_seo_title_reviews": "Reviews | Apartments in Burien WA",
  "property_seo_description_reviews": "Discover life at The Maverick in Burien, WA! Enjoy mountain views, modern amenities, and a vibrant community spirit.",
  "property_seo_title_applynow": "Apply Now | Burien 1 Bedroom Apartment",
  "property_seo_description_applynow": "Spacious 1 and 2 bedroom apartments in Burien, WA are waiting for you at The Maverick. Apply today and find your new home near Seattle.",
  "property_seo_title_residentaccess": "Resident Access | The Maverick | Burien, WA",
  "property_seo_description_residentaccess": "Easily pay rent and request maintenance online through The Maverick’s resident portal. Burien living made simple and seamless.",
  "property_seo_title_referafriend": "Refer a Friend | Homes Near Seattle WA",
  "property_seo_description_referafriend": " Love where you live at The Maverick? Refer a friend to our homes near Seattle and enjoy the rewards of great neighbors.",
  "property_seo_title_scheduletour": "Schedule a Tour | 1 Bedroom Apartment Near Seattle",
  "property_seo_description_scheduletour": "Ready to see The Maverick in person? Schedule a tour today and explore 1 and 2 bedroom homes just minutes from downtown Seattle.",
  "property_seo_title_privacy": "Privacy Policy | The Maverick | Burien, WA",
  "property_seo_description_privacy": "Learn how your information is protected when browsing our Burien, WA apartments for rent near Seattle and Tacoma.",
  "property_seo_title_accessibility": "Accessibility | The Maverick | Burien, WA",
  "property_seo_description_accessibility": "Our website is accessible to all. Learn how The Maverick supports inclusive online access for those looking for homes near Seattle.",
  "property_seo_title_sitemap": "The Maverick | Apartments For Rent In Burien, WA",
  "property_seo_description_sitemap": "Easily find floor plans, amenities, and availability for apartments near Seattle and SeaTac at The Maverick.",
  "property_seo_title_thankyou": "Thank You | Homes Near Burien, WA",
  "property_seo_description_thankyou": "Thanks for contacting The Maverick team. We’ll help you find the perfect apartment near Burien, WA today!",
  "property_seo_title_pets": "Pet Policy | Apartments in Burien, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293635039",
  "amenities": [
    {
      "id": "ec_3afb479035f907bd31b18159",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496260",
      "title": "Media Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88c9d93a54ad275a7bcee3f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496171",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3448fdb0c4d1647fe9e0374",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496172",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_465503bfb977ae8a84afbfb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496174",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2455666b9e79750752c1f45f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496175",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12292a125a50bfb8e8b2935c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496179",
      "title": "Guest Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0060da36d0353097bb6add77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496180",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8aaaf066b7f9fe97746695f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496182",
      "title": "Night Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4901d22bb04e0982be963b0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496183",
      "title": "Off Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_172a954a64fe31f653f57e05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496184",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0429d2daa6c5589f04ea08f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496185",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ccc2137ebc238fefb7dc094",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496186",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_55685b981e6bf8dc30f432fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496187",
      "title": "Short Term Lease",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b28015d9b37c28b4920c1c91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496188",
      "title": "Spanish Speaking Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_219c710ee1dc8024ca123572",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496249",
      "title": "Yoga/Pilates Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09c32713871e5caafd477246",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496250",
      "title": "Controlled Access Electronic Entrance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88841c94f1a879834e316a1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496251",
      "title": "Outdoor Grill & BBQ Area with Seating",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_908c24b668b5208156ff7663",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496252",
      "title": "Bocce Ball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0bde2d906d85bdce26069482",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496215",
      "title": "Bicycle Storage & Repair Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0cc8984b1041ac4264f2006",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496253",
      "title": "Wifi in All Common Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30e37902d2944861a441d720",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496254",
      "title": "Movie Theater",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9ead9ec8b04c1a53d2e774e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496255",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3df7bd0837df3d6f97a5587",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496256",
      "title": "Clubroom with TV & Full Kitchen and Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db59a76d71520d27797c8ede",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496257",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf852aa0bf588afaac5030e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496258",
      "title": "Located Next to Burien Town Square",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2682f7b7193d2689545f4de1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496259",
      "title": "Private Parking Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f288a445d38fb4913e9440e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "128929503",
      "title": "Art Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5136f490fdb66e741f0aba51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496216",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a37714f6b54d00383c93afba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496218",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a5e817eab45c498be596e15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496219",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bfade3ce5298e81ef04fe418",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496220",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41c066002bc3e7e02e7107ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496221",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da6d9dd6f37891744f51e5e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496223",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea945dcae86cc28acdb91319",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496229",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc3af62b6657f9576856979c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496225",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b4ccab1fa8f3d98dcd19e94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496226",
      "title": "*Private Balcony",
      "amount": "false",
      "description": "5 Foot Balcony (in select units only)",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9daf32c8ba673c0b91139df0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496227",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d95bc19a722f41729c4c9c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496228",
      "title": "Air Conditioning Ports",
      "amount": "false",
      "description": "Air Conditioning Ports",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ed9336c82c2c8014967ffd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496232",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6fbce40c022995ee401bb32a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496233",
      "title": "Air Conditioner Ports",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_863b21101fd3c4f80d24b730",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496261",
      "title": "Lofted Townhomes with Direct Entry Access",
      "amount": "false",
      "description": "Lofted One Bedroom Townhome",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd20e9914d18da2ab34ebef6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496262",
      "title": "Two-Tone Designer Paint",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33f3a693ebab1db9a4536f1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496263",
      "title": "Large Windows Throughout the Apartments",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc78f4639b66d1feb4e436a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496264",
      "title": "Custom Light Fixtures in Kitchen and Bathrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4dbded851f53ab350a9caec3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496265",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4a2ca4ea37144b48a47c2e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496269",
      "title": "Gorgeous Mountain Views",
      "amount": "false",
      "description": "Mountain View",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_064884a456e7ff058a8fe8cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496266",
      "title": "Two-Tone White and Espresso Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_372aa3d0a95c5729b7dd7dd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496267",
      "title": "Wood-Like Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f007087d8db534b52dee9db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496268",
      "title": "Plush Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9ef2f2f8dd561b7c1b66435",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85496270",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42b8d26dbebb6995febc68cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85721100",
      "title": "Income Restricted Program - Please Inquire",
      "amount": "false",
      "description": "MFTE 100% of Median Income",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efed3e454fa85712d995e0b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "yardi",
      "external_id": "85721101",
      "title": "Income Restricted Program - Please Inquire",
      "amount": "false",
      "description": "MFTE 150% of Median Income",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_3f8c48e2a2eadfd3ccb6871a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "title": "Community",
      "description": "Enjoy outdoor entertaining in the spacious grilling area, complete with two premium grills and comfortable seating. Perfect for gathering with friends and neighbors.",
      "link": "false",
      "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Maverick Apartments.jpg"
    },
    {
      "id": "ec_fa8181e267b69babf0894c94",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-0242-720e-8dfd-933dd1d8bf9f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white countertops, dark wood cabinets, stainless steel appliances, and pendant lighting.",
        "public_id": "019d0812-0242-720e-8dfd-933dd1d8bf9f",
        "storage_key": "property/6767906449164263/019d0812-0242-720e-8dfd-933dd1d8bf9f.webp",
        "width": 2000,
        "height": 1544
      },
      "title": "Apartment",
      "description": "A stylish and functional kitchen featuring sleek cabinetry, a spacious island, and modern appliances, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Modern kitchen with white countertops, dark wood cabinets, stainless steel appliances, and pendant lighting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Maverick Apartments(7).jpg"
    },
    {
      "id": "ec_20004981e07116a5b94e5d14",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-0c8f-708d-aab1-292504d65778.webp",
      "image_media": {
        "alt_text": "View of a bedroom with a king-size bed, nightstand, and closet.",
        "public_id": "019d0812-0c8f-708d-aab1-292504d65778",
        "storage_key": "property/6767906449164263/019d0812-0c8f-708d-aab1-292504d65778.webp",
        "width": 2500,
        "height": 1931
      },
      "title": "Apartment",
      "description": "Step into comfort and style in our beautifully appointed bedrooms. Perfect for relaxation and a good night's sleep.",
      "link": "false",
      "alt_text": "View of a bedroom with a king-size bed, nightstand, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/170624-20I - low res.jpg"
    },
    {
      "id": "ec_8a7e58659989ed417b2b8b83",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d20ac-143d-76db-9ac3-dde047dd9d9e.webp",
      "image_media": {
        "alt_text": "Modern apartment complex courtyard with artificial turf, seating areas, and mountain views.",
        "public_id": "019d20ac-143d-76db-9ac3-dde047dd9d9e",
        "storage_key": "property/6767906449164263/019d20ac-143d-76db-9ac3-dde047dd9d9e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience outdoor living in this vibrant community courtyard, featuring a central lawn, stylish seating, and a backdrop of majestic mountains.",
      "link": "false",
      "alt_text": "Modern apartment complex courtyard with artificial turf, seating areas, and mountain views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Burien Town Center 2.jpg"
    },
    {
      "id": "ec_d7209330c8d3344b8bdc49af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d20ac-16b9-75d1-b8fd-271a5f2a478b.webp",
      "image_media": {
        "alt_text": "Outdoor patio seating area with fire pit and string lights.",
        "public_id": "019d20ac-16b9-75d1-b8fd-271a5f2a478b",
        "storage_key": "property/6767906449164263/019d20ac-16b9-75d1-b8fd-271a5f2a478b.webp",
        "width": 3072,
        "height": 2374
      },
      "title": "Community",
      "description": "Relax and unwind in the outdoor lounge area, complete with a cozy fire pit and comfortable seating, perfect for enjoying cool evenings.",
      "link": "false",
      "alt_text": "Outdoor patio seating area with fire pit and string lights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/170524-03E.jpg"
    },
    {
      "id": "ec_94c16ce19a86c164d6a1e38f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-15d8-7578-938a-e79d5ce66484.webp",
      "image_media": {
        "alt_text": "Dining area with chairs and table in front of a kitchen with orange refrigerator.",
        "public_id": "019d0812-15d8-7578-938a-e79d5ce66484",
        "storage_key": "property/6767906449164263/019d0812-15d8-7578-938a-e79d5ce66484.webp",
        "width": 2000,
        "height": 1545
      },
      "title": "Community",
      "description": "Enjoy community dining or prepare a meal in the full kitchen, featuring a retro orange refrigerator and ample counter space.",
      "link": "false",
      "alt_text": "Dining area with chairs and table in front of a kitchen with orange refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Maverick Apartments(4).jpg"
    },
    {
      "id": "ec_ddd0a67b629211e5ac1f8dc2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-23a1-7669-b743-4a5b6acc3ec0.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with colorful accents and large windows.",
        "public_id": "019d0812-23a1-7669-b743-4a5b6acc3ec0",
        "storage_key": "property/6767906449164263/019d0812-23a1-7669-b743-4a5b6acc3ec0.webp",
        "width": 2000,
        "height": 1544
      },
      "title": "Community",
      "description": "Showcasing the contemporary architecture of the apartment building, featuring vibrant yellow and grey facade elements and expansive windows, complemented by surrounding greenery.",
      "link": "false",
      "alt_text": "Modern apartment building exterior with colorful accents and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Maverick Apartments(5).jpg"
    },
    {
      "id": "ec_3a7d0f7b365c0e54b5c27d35",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-289d-72ab-bcb8-40e083839233.webp",
      "image_media": {
        "alt_text": "Home theater with rows of reclining leather seats and a large screen displaying a football game.",
        "public_id": "019d0812-289d-72ab-bcb8-40e083839233",
        "storage_key": "property/6767906449164263/019d0812-289d-72ab-bcb8-40e083839233.webp",
        "width": 2000,
        "height": 1545
      },
      "title": "Community",
      "description": "Enjoy movie nights or watch the big game in our state-of-the-art community theater, complete with comfortable seating and a large display screen.",
      "link": "false",
      "alt_text": "Home theater with rows of reclining leather seats and a large screen displaying a football game.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Maverick Apartments(10).jpg"
    },
    {
      "id": "ec_c296c635064c2497847380ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-40a1-767b-9b24-34183a9fcbc2.webp",
      "image_media": {
        "alt_text": "Stacked white washer and dryer with a laundry hamper and clothes on hangers in a closet.",
        "public_id": "019d0812-40a1-767b-9b24-34183a9fcbc2",
        "storage_key": "property/6767906449164263/019d0812-40a1-767b-9b24-34183a9fcbc2.webp",
        "width": 3072,
        "height": 2373
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with a stacked washer and dryer, laundry basket, and ample closet space for your linens and clothing.",
      "link": "false",
      "alt_text": "Stacked white washer and dryer with a laundry hamper and clothes on hangers in a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Maverick - Laundry Room (1).jpg"
    },
    {
      "id": "ec_67d4fb26ec3edf0070d4549b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-3184-7619-880f-abc9b65ce063.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white and gray cabinetry, and hardwood floors.",
        "public_id": "019d0812-3184-7619-880f-abc9b65ce063",
        "storage_key": "property/6767906449164263/019d0812-3184-7619-880f-abc9b65ce063.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this sleek, modern kitchen featuring stainless steel appliances, ample cabinet space, and stylish finishes.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white and gray cabinetry, and hardwood floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Maverick-poi-009(1).jpg"
    },
    {
      "id": "ec_30ae4b09753aa3a5231e3807",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Maverick Apartments(11).jpg",
      "image_media": null,
      "title": "false",
      "description": "false",
      "link": "false",
      "alt_text": "false",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Maverick Apartments(11).jpg"
    },
    {
      "id": "ec_2389dd0b0b61390afb8b65bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-23a1-7669-b743-4a5b6acc3ec0.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with colorful accents and large windows.",
        "public_id": "019d0812-23a1-7669-b743-4a5b6acc3ec0",
        "storage_key": "property/6767906449164263/019d0812-23a1-7669-b743-4a5b6acc3ec0.webp",
        "width": 2000,
        "height": 1544
      },
      "title": "Community",
      "description": "Showcasing the contemporary architecture of the apartment building, featuring vibrant yellow and grey facade elements and expansive windows, complemented by surrounding greenery.",
      "link": "false",
      "alt_text": "Modern apartment building exterior with colorful accents and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Maverick Apartments(5).jpg"
    },
    {
      "id": "ec_3f8a26f5e10ae00e44bf8838",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-3acf-774d-8060-05ae9519bf26.webp",
      "image_media": {
        "alt_text": "Modern staircase with wood treads and metal railings in a bright, open common area with seating.",
        "public_id": "019d0812-3acf-774d-8060-05ae9519bf26",
        "storage_key": "property/6767906449164263/019d0812-3acf-774d-8060-05ae9519bf26.webp",
        "width": 2000,
        "height": 1544
      },
      "title": "Community",
      "description": "Ascend in style via the modern wooden staircase, leading to a vibrant community space with ample seating and contemporary lighting.",
      "link": "false",
      "alt_text": "Modern staircase with wood treads and metal railings in a bright, open common area with seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Maverick Apartments(9).jpg"
    },
    {
      "id": "ec_9e01f9873dbc533a0c7b129e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-4066-73d9-bd3a-0a43cbdd7c0c.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and string lights under a pergola, overlooking a courtyard with green space and apartment buildings.",
        "public_id": "019d0812-4066-73d9-bd3a-0a43cbdd7c0c",
        "storage_key": "property/6767906449164263/019d0812-4066-73d9-bd3a-0a43cbdd7c0c.webp",
        "width": 2000,
        "height": 1546
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and entertaining at our outdoor kitchen, complete with grills and comfortable seating areas. Perfect for gathering with friends and neighbors.",
      "link": "false",
      "alt_text": "Outdoor grilling area with two built-in grills and string lights under a pergola, overlooking a courtyard with green space and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Maverick Apartments(1).jpg"
    },
    {
      "id": "ec_1eb87cf901d346de6846f1e4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-50b3-732b-8849-185c74631c5c.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, nightstand, and a window with a view.",
        "public_id": "019d0812-50b3-732b-8849-185c74631c5c",
        "storage_key": "property/6767906449164263/019d0812-50b3-732b-8849-185c74631c5c.webp",
        "width": 2000,
        "height": 1545
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-sized bed, elegant nightstand, and a large window with scenic views. Perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, nightstand, and a window with a view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Maverick Apartments(3).jpg"
    },
    {
      "id": "ec_1faa5135b2a76885457de06d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d20ac-1af4-735b-b514-204ee5f1b4f2.webp",
      "image_media": {
        "alt_text": "People browsing stalls at an outdoor farmer's market with modern apartment buildings in the background.",
        "public_id": "019d20ac-1af4-735b-b514-204ee5f1b4f2",
        "storage_key": "property/6767906449164263/019d20ac-1af4-735b-b514-204ee5f1b4f2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy the vibrant community atmosphere at the local farmer's market, with fresh produce and beautiful flowers, all just steps from your modern apartment home.",
      "link": "false",
      "alt_text": "People browsing stalls at an outdoor farmer's market with modern apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Burien Town Center 37.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_b8914949-4ee4-4b91-8738-0dbfb6335547",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "15868 1st Ave S, Burien, WA 98148, USA",
      "poi_short_description": "Grocery store with a neighborhood feel carrying a selection of organic products, wine, and prepared foods.",
      "poi_long_description": "Shoppers say this grocery store offers a great selection of goods, including organic food, prepared goods, and reasonably priced items. They also highlight the friendly, helpful, and knowledgeable staff, and appreciate the good deals and tasty treats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-e152-718e-8e30-b424a23231a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-e152-718e-8e30-b424a23231a3",
        "storage_key": "property/6767906449164263/019d0812-e152-718e-8e30-b424a23231a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/burien/133/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6274973072331786337",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.460074",
      "poi_longitude": "-122.3313909",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-901-9339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25de-7129-827f-6deb8db09a87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25de-7129-827f-6deb8db09a87",
        "storage_key": "property/6767906449164263/019d0813-25de-7129-827f-6deb8db09a87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaytCap9EkFQRYUh6V8MuFVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b0979eac-4d6f-499b-896f-eeb82ba31254",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Highline College",
      "poi_type": "Education",
      "poi_address": "2400 S 240th St, Des Moines, WA 98198, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-e235-717f-982f-79d40eeff8e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-e235-717f-982f-79d40eeff8e5",
        "storage_key": "property/6767906449164263/019d0812-e235-717f-982f-79d40eeff8e5.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.highline.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9102534943473461902",
      "poi_item_slug": "highline-college",
      "poi_latitude": "47.38833469999999",
      "poi_longitude": "-122.3017666",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-878-3710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25d1-717c-953f-73c408966eb2",
        "storage_key": "property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf0oT_BNDkFQRjupQxU2zUn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fea4a903-5567-45fa-bab9-f760e0347d92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "South Seattle College",
      "poi_type": "Education",
      "poi_address": "6000 16th Ave SW, Seattle, WA 98106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-e2d8-7062-ae2a-34d314deb682.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-e2d8-7062-ae2a-34d314deb682",
        "storage_key": "property/6767906449164263/019d0812-e2d8-7062-ae2a-34d314deb682.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.southseattle.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13605236372797138528",
      "poi_item_slug": "south-seattle-college",
      "poi_latitude": "47.54804379999999",
      "poi_longitude": "-122.3524481",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-934-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25d1-717c-953f-73c408966eb2",
        "storage_key": "property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE6VQHKRBkFQRYCbMvWWCz7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c1d25638-3755-4811-b789-e02871ddc804",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Valley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "400 S 43rd St, Renton, WA 98055, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-03fd-7777-84d4-7c8f9501e38d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-03fd-7777-84d4-7c8f9501e38d",
        "storage_key": "property/6767906449164263/019d0813-03fd-7777-84d4-7c8f9501e38d.webp",
        "width": 750,
        "height": 500
      },
      "poi_business_url": "http://www.valleymed.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6634061436974118693",
      "poi_item_slug": "valley-medical-center",
      "poi_latitude": "47.4428037",
      "poi_longitude": "-122.2138885",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 425-690-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-2b27-7437-a627-e6821468eae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-2b27-7437-a627-e6821468eae2",
        "storage_key": "property/6767906449164263/019d0813-2b27-7437-a627-e6821468eae2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMS9badNqkFQRJbf1aLrrEFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fe922486-fb6a-458f-8766-d3a62e8fa7ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "St. Anne Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "16251 Sylvester Rd SW, Burien, WA 98166, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-07b5-731d-bc71-c5dec1b27b16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-07b5-731d-bc71-c5dec1b27b16",
        "storage_key": "property/6767906449164263/019d0813-07b5-731d-bc71-c5dec1b27b16.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.vmfh.org/our-hospitals/st-anne-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=10014091768260235562",
      "poi_item_slug": "st-anne-hospital",
      "poi_latitude": "47.4573951",
      "poi_longitude": "-122.3425954",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-244-9970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-2b27-7437-a627-e6821468eae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-2b27-7437-a627-e6821468eae2",
        "storage_key": "property/6767906449164263/019d0813-2b27-7437-a627-e6821468eae2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01Ir55dEkFQRKpFQA2gz-Yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4e5e2f02-98eb-4a47-899e-abb52a82c0d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Lincoln Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8011 Fauntleroy Wy SW, Seattle, WA 98136, USA",
      "poi_short_description": "Park offering a playground, a swimming pool, a beach, trails, and scenic views.",
      "poi_long_description": "Rocky coastline adorned with playgrounds, BBQs, hiking & biking trails & a heated saltwater pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-0b2f-70be-b34e-fdd6bb05027f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-0b2f-70be-b34e-fdd6bb05027f",
        "storage_key": "property/6767906449164263/019d0813-0b2f-70be-b34e-fdd6bb05027f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/lincoln-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16686431432944069629",
      "poi_item_slug": "lincoln-park",
      "poi_latitude": "47.53057099999999",
      "poi_longitude": "-122.395992",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-313b-77f8-9c72-8d1288f338bf",
        "storage_key": "property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnRb12DlBkFQR_SuL0fockuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7daeac33-097a-4158-873e-dd2451b9d4f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Kubota Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9817 55th Ave S, Seattle, WA 98118, USA",
      "poi_short_description": "Garden known for its waterfalls and rhododendrons, with well-maintained trails and picnic tables.",
      "poi_long_description": "Visitors say this Japanese garden offers a peaceful escape with well-maintained walking paths, stunning views, and a variety of plant species, including rhododendrons, azaleas, and koi fish. They also highlight the garden's serene atmosphere, free admission, and convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-0b46-716d-a76e-07035539baab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-0b46-716d-a76e-07035539baab",
        "storage_key": "property/6767906449164263/019d0813-0b46-716d-a76e-07035539baab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kubotagarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16083961869648009774",
      "poi_item_slug": "kubota-garden",
      "poi_latitude": "47.5134676",
      "poi_longitude": "-122.2658737",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-725-5060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-313b-77f8-9c72-8d1288f338bf",
        "storage_key": "property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2y97GVCkFQRLhpMnRq2Nd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_6f7da098-0b1b-4543-8227-aa0d34722000",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Seahurst Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 SW Seahurst Park Rd, Burien, WA 98166, USA",
      "poi_short_description": "Beach featuring a playground and picnic areas, plus opportunities for walking and tide-watching.",
      "poi_long_description": "Visitors say this park offers beautiful beach access, hiking trails, and a relaxing atmosphere with stunning views of Puget Sound and the Olympic Mountains. They also highlight the family-friendly environment with picnic areas, a playground, and ample open space for games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-0b8b-77cb-af1b-a0458a8fc1a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-0b8b-77cb-af1b-a0458a8fc1a7",
        "storage_key": "property/6767906449164263/019d0813-0b8b-77cb-af1b-a0458a8fc1a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://burienwa.gov/residents/parks_recreation_cultural_services/city_parks_trails_facilities/seahurst_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18197522955814146684",
      "poi_item_slug": "seahurst-park",
      "poi_latitude": "47.4762175",
      "poi_longitude": "-122.3602348",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-988-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-313b-77f8-9c72-8d1288f338bf",
        "storage_key": "property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbgYQHlEkFQRfJJRtbaWivw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_70b6044c-33f3-4ffa-a28f-a664a4fd7c21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Angle Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19408 International Blvd, SeaTac, WA 98188, USA",
      "poi_short_description": "This green space with a lake offers amenities such as a boat launch, playground & water spray park.",
      "poi_long_description": "Visitors say this park offers a splash pad, playground, and a lake with swimming and fishing opportunities. They also highlight the relaxing atmosphere, beautiful scenery, and family-friendly environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-0ef5-73d8-bfb2-6369c43f5bf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-0ef5-73d8-bfb2-6369c43f5bf1",
        "storage_key": "property/6767906449164263/019d0813-0ef5-73d8-bfb2-6369c43f5bf1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seatacwa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10463006071752659881",
      "poi_item_slug": "angle-lake-park",
      "poi_latitude": "47.428313",
      "poi_longitude": "-122.294627",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-973-4680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-313b-77f8-9c72-8d1288f338bf",
        "storage_key": "property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS7NCsWBbkFQRqZOSPZYQNJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ff138a72-e090-429a-a4e8-c21b4585669f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Seattle Chinese Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6000 16th Ave SW, Seattle, WA 98106, USA",
      "poi_short_description": "Traditional elements of stone, water & plants in a tranquil setting, plus arts & education venues.",
      "poi_long_description": "Visitors say this garden offers a magical experience with stunning laser lights and synchronized music. They also highlight that it's a great place for families and couples to enjoy a unique and memorable outing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-1195-7549-9a76-10633569678e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0813-1195-7549-9a76-10633569678e",
        "storage_key": "property/6767906449164263/019d0813-1195-7549-9a76-10633569678e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattlechinesegarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10097941026226714072",
      "poi_item_slug": "seattle-chinese-garden",
      "poi_latitude": "47.5517747",
      "poi_longitude": "-122.3524943",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 206-934-5219",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-313b-77f8-9c72-8d1288f338bf",
        "storage_key": "property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSZWuqVBkFQR2DUWt9wXI4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_42986cef-ede0-42da-9d44-e645ef1483a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Seattle-Tacoma International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17801 International Blvd, SeaTac, WA 98158, USA",
      "poi_short_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_long_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-c080-7363-8b12-62e879cc0772.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c080-7363-8b12-62e879cc0772",
        "storage_key": "property/6767906449164263/019dbbe6-c080-7363-8b12-62e879cc0772.webp",
        "width": 1200,
        "height": 798
      },
      "poi_business_url": "https://www.portseattle.org/sea-tac",
      "poi_directions_map_url": "https://maps.google.com/?cid=11084442547078838199&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "seattle-tacoma-international-airport",
      "poi_latitude": "47.4483652",
      "poi_longitude": "-122.3085927",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-313e-739d-b905-b13cef8144af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-313e-739d-b905-b13cef8144af",
        "storage_key": "property/6767906449164263/019d0813-313e-739d-b905-b13cef8144af.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f7qQlVDkFQRtzfcx8TZ05k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_a41ee364-16f6-4d45-9dd6-13ea460a0832",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Alaska Airlines - Seattle, WA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17801 International Blvd, Seattle, WA 98158, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-20e8-74b9-80f3-cf81c2b75453.webp",
      "poi_featured_image_media": {
        "alt_text": "Alaska Airlines Boeing 737 aircraft flying over mountains.",
        "public_id": "019d0813-20e8-74b9-80f3-cf81c2b75453",
        "storage_key": "property/6767906449164263/019d0813-20e8-74b9-80f3-cf81c2b75453.webp",
        "width": 1800,
        "height": 1200
      },
      "poi_business_url": "https://www.alaskaair.com/content/airports/washington/seattle/seattle-tacoma-international",
      "poi_directions_map_url": "https://maps.google.com/?cid=13987648440154980727&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "alaska-airlines---seattle-wa",
      "poi_latitude": "47.4438794",
      "poi_longitude": "-122.3022429",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 800-252-7522",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-2b23-70eb-83c3-96c161615a6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-2b23-70eb-83c3-96c161615a6d",
        "storage_key": "property/6767906449164263/019d0813-2b23-70eb-83c3-96c161615a6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFWrupKtckFQRdwF8hiUcHsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_348915f9-b093-42cc-8eb2-d9d8262f3eb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Highline Medical Pavilion",
      "poi_type": "Major Employers & Offices",
      "poi_address": "16045 1st Ave S, Burien, WA 98148, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-c188-76c9-9e31-52073750a28b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c188-76c9-9e31-52073750a28b",
        "storage_key": "property/6767906449164263/019dbbe6-c188-76c9-9e31-52073750a28b.webp",
        "width": 606,
        "height": 1280
      },
      "poi_business_url": "https://www.chifranciscan.org/franciscan-medical-pavilion-highline.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=15784462616445018238&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "highline-medical-pavilion",
      "poi_latitude": "47.458497",
      "poi_longitude": "-122.3350225",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-965-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-2b23-70eb-83c3-96c161615a6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-2b23-70eb-83c3-96c161615a6d",
        "storage_key": "property/6767906449164263/019d0813-2b23-70eb-83c3-96c161615a6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx5hlFaJEkFQRfmCjtx6tDds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_713cb9d7-97f5-4836-9ed8-a93499380fac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Marlaina's Mediterranean Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "643 SW 152nd St, Burien, WA 98166, USA",
      "poi_short_description": "Regional Mediterranean fare from slow-roasted meats to vegan items in a comfy storefront space.",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious dishes like Mesopotamian Lamb and Beef, Gyro Plate, and Mezze Platter. They highlight the generous portions, home-cooked feel, and affordable prices. They also like the warm, cozy, and inviting atmosphere, and the friendly, attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-c449-7288-a6b2-f171171cfc6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c449-7288-a6b2-f171171cfc6a",
        "storage_key": "property/6767906449164263/019dbbe6-c449-7288-a6b2-f171171cfc6a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://marlainasrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1971393934860287282&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "marlainas-mediterranean-kitchen",
      "poi_latitude": "47.46663419999999",
      "poi_longitude": "-122.3437848",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-535-6420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25d8-7528-a291-e145b6efbd3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25d8-7528-a291-e145b6efbd3a",
        "storage_key": "property/6767906449164263/019d0813-25d8-7528-a291-e145b6efbd3a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0UhMZ5tEkFQRMv20v1bMWxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_c0a15298-389c-4ef7-b97d-f8d11d38c12b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Centro Neighborhood Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "643 SW 152nd St Suite A, Burien, WA 98166, USA",
      "poi_short_description": "Casual eatery specializing in family-friendly Mexican fare like tacos and enchiladas, margaritas and cocktails.",
      "poi_long_description": "People say this restaurant serves delicious tacos, burritos, and bowls, with options like fish, asada, and vegan choices. They highlight the fresh, flavorful ingredients, and the generous portions of meat in the tacos. They also like the fun, neighborhood vibe and the attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-c61d-76e1-9fbb-82067c08b0f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c61d-76e1-9fbb-82067c08b0f2",
        "storage_key": "property/6767906449164263/019dbbe6-c61d-76e1-9fbb-82067c08b0f2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.centroburien.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6353960747892624378&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "centro-neighborhood-kitchen",
      "poi_latitude": "47.4666401",
      "poi_longitude": "-122.3438519",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-420-7227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25d8-7528-a291-e145b6efbd3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25d8-7528-a291-e145b6efbd3a",
        "storage_key": "property/6767906449164263/019d0813-25d8-7528-a291-e145b6efbd3a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrZzaxmlFkFQR-kvqrqLNLVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1bdc7e33-bfbf-4adb-9958-38dc01c34cd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Elliott Bay Brewing - Burien",
      "poi_type": "Restaurants",
      "poi_address": "255 SW 152nd St, Burien, WA 98166, USA",
      "poi_short_description": "Family-owned brewpub offering small plates, burgers & seafood, plus seasonal & specialty beers.",
      "poi_long_description": "People say this brewpub serves up delicious burgers, fish and chips, and chicken sandwiches, alongside a great selection of beers, including a standout pilsner. They also highlight the friendly and knowledgeable service, and the pet-friendly patio.\n\nSome reviews mention the atmosphere can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6ece-f5c8-739c-852f-4bb171491151.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Elliott Bay Brewhouse and Pub with outdoor seating area.",
        "public_id": "019d6ece-f5c8-739c-852f-4bb171491151",
        "storage_key": "property/6767906449164263/019d6ece-f5c8-739c-852f-4bb171491151.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.elliottbaybrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13968484666211366962&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "elliott-bay-brewing---burien",
      "poi_latitude": "47.46663059999999",
      "poi_longitude": "-122.3389361",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-246-4211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-ef55-723a-9cfa-6132861612ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dbbe6-ef55-723a-9cfa-6132861612ae",
        "storage_key": "property/6767906449164263/019dbbe6-ef55-723a-9cfa-6132861612ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQypYVJxEkFQRMvgEtMsG2sE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_1b4d6580-55fb-46dd-a2e0-b1f8c511978c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Smarty Pants Garage",
      "poi_type": "Restaurants",
      "poi_address": "626 SW 152nd St, Burien, WA 98166, USA",
      "poi_short_description": "Easygoing, casual eatery with a patio offering up standard pub grub alongside a full bar.",
      "poi_long_description": "People say this restaurant serves a nice selection of savory and sweet breakfast items, including large pancakes, and delicious sandwiches, burgers, and entrees. They also highlight the fun, laid-back vibe, the friendly and attentive service, and the reasonable prices.\n\nOther reviews mention the food can be spicy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-cbd5-713c-8faa-8fa17131761e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-cbd5-713c-8faa-8fa17131761e",
        "storage_key": "property/6767906449164263/019dbbe6-cbd5-713c-8faa-8fa17131761e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.smartypantsgarage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17593711498110552602&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smarty-pants-garage",
      "poi_latitude": "47.46710119999999",
      "poi_longitude": "-122.3430751",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-457-8181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25d8-7528-a291-e145b6efbd3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25d8-7528-a291-e145b6efbd3a",
        "storage_key": "property/6767906449164263/019d0813-25d8-7528-a291-e145b6efbd3a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4SDpJxEkFQRGsqVXWRrKfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8ceb93a2-8c21-4f7c-9d0c-7a5ed162e287",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Burien Press",
      "poi_type": "Restaurants",
      "poi_address": "423 SW 152nd St, Burien, WA 98166, USA",
      "poi_short_description": "Relaxed, timber-lined coffeehouse serving specialty drinks alongside baked goods & bites.",
      "poi_long_description": "People say this coffee shop offers excellent coffee, including a surprising Espresso Tonic + Orange, and a great selection of drinks, baked goods, and beer. They highlight the cozy and modern vibe, the hidden back patio, and the attention to detail in the coffee preparation. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-cf54-77d8-b1c4-5c988ce8068f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-cf54-77d8-b1c4-5c988ce8068f",
        "storage_key": "property/6767906449164263/019dbbe6-cf54-77d8-b1c4-5c988ce8068f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.burienpress.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4475209147149045462&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "burien-press",
      "poi_latitude": "47.466694",
      "poi_longitude": "-122.340258",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-453-5412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-f317-73cd-bc6b-9175e4273296.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dbbe6-f317-73cd-bc6b-9175e4273296",
        "storage_key": "property/6767906449164263/019dbbe6-f317-73cd-bc6b-9175e4273296.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJVb4Y8ZxEkFQR1s5lNwIjGz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_fca07b68-edc8-4e60-96fa-d451d12d2fca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Bakery Nouveau",
      "poi_type": "Restaurants",
      "poi_address": "426 SW 153rd St, Burien, WA 98166, USA",
      "poi_short_description": "Casual, counter-serve bakery doling out baked goods, chocolates, coffee & unique sandwiches.",
      "poi_long_description": "People say this bakery offers delicious cakes, pastries, breads, and sandwiches, as well as coffee and other drinks. They highlight the fresh, high-quality ingredients, and the beautiful, fun atmosphere with a view of the chocolate-making area. They also like the friendly, helpful, and efficient staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6ecf-2434-7322-a671-15c6594d66de.webp",
      "poi_featured_image_media": {
        "alt_text": "Display case filled with various pastries and baked goods.",
        "public_id": "019d6ecf-2434-7322-a671-15c6594d66de",
        "storage_key": "property/6767906449164263/019d6ecf-2434-7322-a671-15c6594d66de.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.bakerynouveau.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12468693078498475214&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bakery-nouveau",
      "poi_latitude": "47.466204",
      "poi_longitude": "-122.340425",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-717-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25d8-7528-a291-e145b6efbd3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25d8-7528-a291-e145b6efbd3a",
        "storage_key": "property/6767906449164263/019d0813-25d8-7528-a291-e145b6efbd3a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJte_5YJxEkFQRzvxF_UqyCa0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_2fb5acb6-469c-4972-9c2f-fbeddd75310c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "138 SW 148th St, Burien, WA 98166, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "People say this grocery store offers fresh produce, a good selection of food, and a convenient drive-up and go service.\n\nOther reviews mention the service can be unhelpful and the store can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-cec0-7605-bfcb-e068a83419cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-cec0-7605-bfcb-e068a83419cf",
        "storage_key": "property/6767906449164263/019dbbe6-cec0-7605-bfcb-e068a83419cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.safeway.com/safeway/wa/burien/138-sw-148th-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7149873605649033581&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "47.4716442",
      "poi_longitude": "-122.3368228",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-243-3043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25de-7129-827f-6deb8db09a87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25de-7129-827f-6deb8db09a87",
        "storage_key": "property/6767906449164263/019d0813-25de-7129-827f-6deb8db09a87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd32NNX1DkFQRbemmpSl0OWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0d7992c2-e40c-4b13-9496-3f4f34816c0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "PCC Community Markets - Burien Co-op",
      "poi_type": "Shopping & Retail",
      "poi_address": "15840 1st Ave S Suite #102, Burien, WA 98148, USA",
      "poi_short_description": "Grocery store chain offering a variety of organic items and prepared foods.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, delicious pre-made food options, and imported organic coffees. They also highlight the friendly staff, warm ambiance, and convenient access.\n\nOther reviews mention the prices can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6ecf-b222-740d-9f7f-0d3681a47647.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of PCC Community Markets building with large sign and outdoor seating.",
        "public_id": "019d6ecf-b222-740d-9f7f-0d3681a47647",
        "storage_key": "property/6767906449164263/019d6ecf-b222-740d-9f7f-0d3681a47647.webp",
        "width": 1600,
        "height": 900
      },
      "poi_business_url": "https://www.pccmarkets.com/stores/burien/?utm_source=google&utm_medium=gmb&utm_campaign=burien",
      "poi_directions_map_url": "https://maps.google.com/?cid=18238204381765257030&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pcc-community-markets---burien-co-op",
      "poi_latitude": "47.4610521",
      "poi_longitude": "-122.3316731",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-708-6908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25de-7129-827f-6deb8db09a87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25de-7129-827f-6deb8db09a87",
        "storage_key": "property/6767906449164263/019d0813-25de-7129-827f-6deb8db09a87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV7LRiaJFkFQRRkcXTEEeG_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_09678035-9654-4079-bdcb-4fc33699262d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "14300 1st Ave S, Burien, WA 98168, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "People say this grocery store offers a wide selection of items, including groceries, clothing, home goods, and more. They also highlight the friendly and helpful staff, and the clean and well-stocked shelves.\n\nOther reviews mention the parking lot can be full.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6ecc-a479-76ae-98ab-7c752d00c28b.webp",
      "poi_featured_image_media": {
        "alt_text": "Fred Meyer store exterior with shopping carts and a red car.",
        "public_id": "019d6ecc-a479-76ae-98ab-7c752d00c28b",
        "storage_key": "property/6767906449164263/019d6ecc-a479-76ae-98ab-7c752d00c28b.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/wa/burien/burien/701/00028?cid=loc_70100028_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9956410243812089222&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "47.4751906",
      "poi_longitude": "-122.3315642",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-433-6411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25de-7129-827f-6deb8db09a87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25de-7129-827f-6deb8db09a87",
        "storage_key": "property/6767906449164263/019d0813-25de-7129-827f-6deb8db09a87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3buWuntDkFQRht16jF1GLIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_eb8ead92-5f73-47d7-aefe-8f0d2bc6c3fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Westfield Southcenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2800 Southcenter Mall, Seattle, WA 98188, USA",
      "poi_short_description": "2-level indoor shopping mall with more than 200 stores & eateries plus a multiplex with IMAX.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including popular brands and unique boutiques, as well as diverse dining options and entertainment venues. They also highlight the spacious, modern design, convenient parking, and clean facilities.\n\nSome reviews mention the mall can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0812-da94-7478-9129-cbaa4aa411d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-da94-7478-9129-cbaa4aa411d2",
        "storage_key": "property/6767906449164263/019d0812-da94-7478-9129-cbaa4aa411d2.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.westfield.com/en/united-states/southcenter",
      "poi_directions_map_url": "https://maps.google.com/?cid=7722388109786479024&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "westfield-southcenter",
      "poi_latitude": "47.4588849",
      "poi_longitude": "-122.257964",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-246-0423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25c1-7043-b3ca-3841372c6972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25c1-7043-b3ca-3841372c6972",
        "storage_key": "property/6767906449164263/019d0813-25c1-7043-b3ca-3841372c6972.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1W80hNNckFQRsPmFJRJvK2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a5c2cc88-7f6d-4fa3-aa95-4db9bbd89e9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Discover Burien",
      "poi_type": "Entertainment",
      "poi_address": "611 SW 152nd St, Burien, WA 98166, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-d60e-7765-b558-cba63222c219.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d60e-7765-b558-cba63222c219",
        "storage_key": "property/6767906449164263/019dbbe6-d60e-7765-b558-cba63222c219.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.discoverburien.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=53923347984502059&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "discover-burien",
      "poi_latitude": "47.4666862",
      "poi_longitude": "-122.3426132",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-433-2882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-2b23-70eb-83c3-96c161615a6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-2b23-70eb-83c3-96c161615a6d",
        "storage_key": "property/6767906449164263/019d0813-2b23-70eb-83c3-96c161615a6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0GTMINEkFQRK0230f-SvwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_363dad88-cdc9-4e5e-980e-63deed5cb18a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Highline Performing Art Center",
      "poi_type": "Entertainment",
      "poi_address": "401 S 152nd St, Burien, WA 98148, USA",
      "poi_short_description": "Casual performing arts theater hosting school plays and graduation ceremonies, plus dance competitions.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-d65b-7719-b2a8-25b895cbc86a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d65b-7719-b2a8-25b895cbc86a",
        "storage_key": "property/6767906449164263/019dbbe6-d65b-7719-b2a8-25b895cbc86a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.highlinepac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1069137129290522735&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "highline-performing-art-center",
      "poi_latitude": "47.4666331",
      "poi_longitude": "-122.3288645",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-631-6795",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-2b23-70eb-83c3-96c161615a6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-2b23-70eb-83c3-96c161615a6d",
        "storage_key": "property/6767906449164263/019d0813-2b23-70eb-83c3-96c161615a6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY3R-f2FDkFQRb-CK941W1g4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_aebdbde2-c0f4-4519-ab4e-122be78fb42b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "The Point",
      "poi_type": "Entertainment",
      "poi_address": "435 SW 152nd St, Burien, WA 98166, USA",
      "poi_short_description": "Narrow, spacious sports bar with basic pub grub, TVs plus a full list of craft beer & cocktails.",
      "poi_long_description": "People say this sports bar serves delicious burgers, sliders, wings, and cheese curds, and offers a variety of dipping sauces. They highlight the fun and relaxed atmosphere, and the friendly and attentive service. They also like the cool and well-designed interior.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-d5fc-737a-85dd-2211b83882f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d5fc-737a-85dd-2211b83882f3",
        "storage_key": "property/6767906449164263/019dbbe6-d5fc-737a-85dd-2211b83882f3.webp",
        "width": 1280,
        "height": 684
      },
      "poi_business_url": "https://www.thepointburien.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5363167213045648408&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-point",
      "poi_latitude": "47.4665664",
      "poi_longitude": "-122.3407865",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-535-7455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-ef55-723a-9cfa-6132861612ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dbbe6-ef55-723a-9cfa-6132861612ae",
        "storage_key": "property/6767906449164263/019dbbe6-ef55-723a-9cfa-6132861612ae.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkZepjJxEkFQRGIybPCrMbUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "custom_4ecb950d-ee6d-473d-bf79-2981c00a39fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Burien Farmers Market",
      "poi_type": "Entertainment",
      "poi_address": "427 SW 152nd St, Burien, WA 98166, USA",
      "poi_short_description": "Market with a wide variety of vendors selling items like vegetables, barbecue, flowers, and jewelry.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-d977-74ff-a701-7a4ca6f93903.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d977-74ff-a701-7a4ca6f93903",
        "storage_key": "property/6767906449164263/019dbbe6-d977-74ff-a701-7a4ca6f93903.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.burienwa.gov/news_events/featured_events/farmers_market",
      "poi_directions_map_url": "https://maps.google.com/?cid=16403049642177005762&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "burien-farmers-market",
      "poi_latitude": "47.4671799",
      "poi_longitude": "-122.3405128",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-433-2882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25c1-7043-b3ca-3841372c6972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25c1-7043-b3ca-3841372c6972",
        "storage_key": "property/6767906449164263/019d0813-25c1-7043-b3ca-3841372c6972.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE1cE7pxEkFQRwggPE75Wo-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "custom_7960964e-86e5-4a1e-9bf9-d1b5942ab6e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Logan Brewing Company - Burien Taproom",
      "poi_type": "Entertainment",
      "poi_address": "510 SW 151st St, Burien, WA 98166, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6ed1-4aa0-74ed-9380-4cd0096e197b.webp",
      "poi_featured_image_media": {
        "alt_text": "A glass of Logan Brewing Company beer sits on a wooden bar.",
        "public_id": "019d6ed1-4aa0-74ed-9380-4cd0096e197b",
        "storage_key": "property/6767906449164263/019d6ed1-4aa0-74ed-9380-4cd0096e197b.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.logan.beer/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3256036641927600391&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "logan-brewing-company---burien-taproom",
      "poi_latitude": "47.4678665",
      "poi_longitude": "-122.3409745",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-486-6569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-2b23-70eb-83c3-96c161615a6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-2b23-70eb-83c3-96c161615a6d",
        "storage_key": "property/6767906449164263/019d0813-2b23-70eb-83c3-96c161615a6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1-BYapFkFQRBxnAGRPELy0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_6bb0120d-dfba-4ab5-ad4f-8c1de54c8944",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "CHOICE Academy",
      "poi_type": "Education",
      "poi_address": "18367 8th Ave S, Des Moines, WA 98148, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://choice.highlineschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1436293745135114030&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "choice-academy",
      "poi_latitude": "47.4377191",
      "poi_longitude": "-122.3251459",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-631-7630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25d1-717c-953f-73c408966eb2",
        "storage_key": "property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMTfehktbkFQRLtfkJ4297hM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_3f922df6-f850-4682-a3e9-569044f06a4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Highline High School",
      "poi_type": "Education",
      "poi_address": "225 S 152nd St, Burien, WA 98148, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-df38-7754-84e6-3149f6a03d47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-df38-7754-84e6-3149f6a03d47",
        "storage_key": "property/6767906449164263/019dbbe6-df38-7754-84e6-3149f6a03d47.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://hhs.highlineschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12793019539163289254&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "highline-high-school",
      "poi_latitude": "47.4665609",
      "poi_longitude": "-122.3304215",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-631-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25d1-717c-953f-73c408966eb2",
        "storage_key": "property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgRP-iGFDkFQRppZ1lH3vibE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_469c7d45-11a6-4ac5-86f7-a5711d4dce21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Sylvester Middle School",
      "poi_type": "Education",
      "poi_address": "16222 Sylvester Rd SW, Burien, WA 98166, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.highlineschools.org/sylvester",
      "poi_directions_map_url": "https://maps.google.com/?cid=10656006280881875620&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sylvester-middle-school",
      "poi_latitude": "47.4576946",
      "poi_longitude": "-122.3396508",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-631-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25d1-717c-953f-73c408966eb2",
        "storage_key": "property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe7mrpKJEkFQRpKpLKEG94ZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6833dae9-c676-4d25-b881-4cef3cbfc7b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Gregory Heights Elementary",
      "poi_type": "Education",
      "poi_address": "16201 16th Ave SW, Burien, WA 98166, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-e06d-75ed-8ea2-4819e18cf26a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e06d-75ed-8ea2-4819e18cf26a",
        "storage_key": "property/6767906449164263/019dbbe6-e06d-75ed-8ea2-4819e18cf26a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.highlineschools.org/gregoryheights",
      "poi_directions_map_url": "https://maps.google.com/?cid=7912929864879990045&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gregory-heights-elementary",
      "poi_latitude": "47.457945",
      "poi_longitude": "-122.355948",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-631-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25d1-717c-953f-73c408966eb2",
        "storage_key": "property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoS3JvJREkFQRHWXAoMlf0G0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ddcca106-2956-4f40-adf9-c1299a16cf98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Seahurst Elementary School",
      "poi_type": "Education",
      "poi_address": "14603 14th Ave SW, Burien, WA 98166, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.highlineschools.org/seahurst",
      "poi_directions_map_url": "https://maps.google.com/?cid=16813266896321303079&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "seahurst-elementary-school",
      "poi_latitude": "47.471342",
      "poi_longitude": "-122.354006",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-631-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25d1-717c-953f-73c408966eb2",
        "storage_key": "property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHxyVjIZEkFQRJ9IQZSm5VOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_07e339f5-9ec2-43ac-8201-45cdfb1ac6a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Three Tree Montessori School",
      "poi_type": "Education",
      "poi_address": "220 SW 160th St, Burien, WA 98166, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6ed0-34f8-71bc-96fd-c792cf394e99.webp",
      "poi_featured_image_media": {
        "alt_text": "Children in a Montessori classroom engaging in learning activities",
        "public_id": "019d6ed0-34f8-71bc-96fd-c792cf394e99",
        "storage_key": "property/6767906449164263/019d6ed0-34f8-71bc-96fd-c792cf394e99.webp",
        "width": 2048,
        "height": 1366
      },
      "poi_business_url": "http://www.threetree.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7514105248107092135&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "three-tree-montessori-school",
      "poi_latitude": "47.460198",
      "poi_longitude": "-122.336812",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-242-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25d1-717c-953f-73c408966eb2",
        "storage_key": "property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK9Z0vJhEkFQRp1hSZul2R2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d7fa0826-ac34-4c52-9c02-8e0909fdebb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Burien Library",
      "poi_type": "Education",
      "poi_address": "400 SW 152nd St STE 100, Burien, WA 98166, USA",
      "poi_short_description": "Large, welcoming library, with a fountain, which offers study spaces and computers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-e3c9-7247-b245-2e6e599d1e16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e3c9-7247-b245-2e6e599d1e16",
        "storage_key": "property/6767906449164263/019dbbe6-e3c9-7247-b245-2e6e599d1e16.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://kcls.org/locations/burien/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16407738581555677008&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "burien-library",
      "poi_latitude": "47.4670576",
      "poi_longitude": "-122.3398863",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-243-3490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-25d1-717c-953f-73c408966eb2",
        "storage_key": "property/6767906449164263/019d0813-25d1-717c-953f-73c408966eb2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJva2ZiYJEkFQRUAcZ2U7_s-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_eb436cb6-9d07-4864-a429-c4d5f40a739e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Town Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "480 SW 152nd St, Burien, WA 98166, USA",
      "poi_short_description": "Charming park with a grass area featuring a fountain and a playground for kids.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6ed0-dd9f-765d-87a4-ebcf77b8c6df.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern abstract playground structure with a circular design.",
        "public_id": "019d6ed0-dd9f-765d-87a4-ebcf77b8c6df",
        "storage_key": "property/6767906449164263/019d6ed0-dd9f-765d-87a4-ebcf77b8c6df.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.burienwa.gov/residents/parks_recreation_cultural_services/city_parks_trails_facilities/town_square_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2305121260193705078&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "town-square-park",
      "poi_latitude": "47.4674276",
      "poi_longitude": "-122.3402684",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-988-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-313b-77f8-9c72-8d1288f338bf",
        "storage_key": "property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLaGO5pxEkFQRduwLtpJv_R8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_891e8934-10c9-444d-98b3-e5742b54c85c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Dottie Harper Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "421 SW 146th St, Burien, WA 98166, USA",
      "poi_short_description": "Relaxed park with slides, swings and benches, as well as a skate park and a kids' play area, plus a community center.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019dbbe6-e790-7602-8803-80a4d5d8b35b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e790-7602-8803-80a4d5d8b35b",
        "storage_key": "property/6767906449164263/019dbbe6-e790-7602-8803-80a4d5d8b35b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.burienwa.gov/residents/parks_recreation_cultural_services/city_parks_trails_facilities/dottie_harper_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3987389331115117267&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dottie-harper-park",
      "poi_latitude": "47.4716989",
      "poi_longitude": "-122.3400329",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-988-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-313b-77f8-9c72-8d1288f338bf",
        "storage_key": "property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvd43fn1DkFQR04pMdngNVjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2aa9c1fd-c7f0-433a-a245-06228600ff7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Salmon Creek Ravine Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12540 Shorewood Pl SW, Burien, WA 98146, USA",
      "poi_short_description": "This 88-acre forested park along a ravine features primitive hiking trails, a stream & wildlife.",
      "poi_long_description": "This 88-acre forested park along a ravine features primitive hiking trails, a stream & wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6ed3-101b-71bc-8dd2-c34ad7245f27.webp",
      "poi_featured_image_media": {
        "alt_text": "A dirt path winds through a lush forest with tall trees and dense undergrowth.",
        "public_id": "019d6ed3-101b-71bc-8dd2-c34ad7245f27",
        "storage_key": "property/6767906449164263/019d6ed3-101b-71bc-8dd2-c34ad7245f27.webp",
        "width": 600,
        "height": 399
      },
      "poi_business_url": "https://www.burienwa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1775825867003125719&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "salmon-creek-ravine-park",
      "poi_latitude": "47.4921113",
      "poi_longitude": "-122.35637740000001",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-988-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-313b-77f8-9c72-8d1288f338bf",
        "storage_key": "property/6767906449164263/019d0813-313b-77f8-9c72-8d1288f338bf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-RsmD4xDkFQR19-roTcApRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_114d84c4-5fae-49ad-9fe6-969153bb6925",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "poi_name": "Highline SeaTac Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13735 24th Ave S, SeaTac, WA 98168, USA",
      "poi_short_description": "Free-admission botanical garden with themed areas, a Japanese landscape garden & guided tours.",
      "poi_long_description": "People say this botanical garden offers a variety of specialized gardens, including a Japanese garden, rose garden, and iris garden, as well as walking trails. They highlight the serene and relaxing atmosphere, and the beautiful, fragrant flowers. They also like the free admission and convenient location near the airport.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6ecd-2cb2-722a-83ef-05f40476193a.webp",
      "poi_featured_image_media": {
        "alt_text": "Japanese garden with stone bridge over pond and lush greenery.",
        "public_id": "019d6ecd-2cb2-722a-83ef-05f40476193a",
        "storage_key": "property/6767906449164263/019d6ecd-2cb2-722a-83ef-05f40476193a.webp",
        "width": 3072,
        "height": 2758
      },
      "poi_business_url": "http://www.highlinegarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16179141181190658914&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "highline-seatac-botanical-garden",
      "poi_latitude": "47.4795849",
      "poi_longitude": "-122.3037382",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 206-391-4003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0813-2b23-70eb-83c3-96c161615a6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0813-2b23-70eb-83c3-96c161615a6d",
        "storage_key": "property/6767906449164263/019d0813-2b23-70eb-83c3-96c161615a6d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1MKBw5DkFQRYlvD-y7bh-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    }
  ],
  "office_hours": [
    {
      "id": "ec_abb76a3955761f1c4194c1e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2a33d3226890ee7922c5cdda",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fe920cd780d86bd37ebc1883",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1aca07616de461370e28968a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b19de764a8f01a10b99cd012",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_54d1f23b6c4875b86546738d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_9829e776-8de6-4153-81be-a936ae909399",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "rating": "5.0",
      "name": "Alana Grace",
      "text": "Maverick is such a great place to live! I've been here for two months, and what I can say is how kind and helpful all of the staff are. They've been super accommodating, and they make it feel like a community which I really appreciate. Maintenance is really efficient and timely. It's a great location downtown, and there are lots of things to do.",
      "date": "2025-09-27",
      "title": ""
    },
    {
      "id": "custom_6b8557e8-781d-4863-9fa2-0e95526d58f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "rating": "5.0",
      "name": "Jocelyn Torres Mora",
      "text": "Everything about the maverick is wonderful! The staff is so lovely and friendly too! They are so quick to get back to me whenever I do reach out to them. Maintenance is also on top of it as well. Anytime that I put in a maintenance request its fixed the same day. Living here has been such a great experience,  and all the amenities are also a huge perk as well!",
      "date": "2025-04-21",
      "title": ""
    },
    {
      "id": "custom_f73f5bfa-51d0-4ada-b109-c01100c20dc2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "rating": "5.0",
      "name": "Jennifer French",
      "text": "I have been a resident since day 1, and have definitely had only positive experiences. The people on my floor seem respectful, and it's a quite, courteous floor. I lived in a \"luxury\" apartment building downtown and experienced similar issues with noise, smell, homeless individuals that I see mentioned  in other Maverick reviews, but for nearly 2x the rent. (Including hearing my next door neighbor using the bathroom because cement floors create weird sound patterns.) The staff does  keep the common areas clean, neat, and maintained (including landscaping), both inside and outside. They have also been very responsive with issues I've had in the unit, from a noisy freezer fan to a leaking fire sprinkler.\n\nYeah, the appliances are a little on the inexpensive side. But try living in a \"green building\" with a European size refrigerator (as in, xxx small) and no garbage disposal.\n\nOne issue I have noticed is sound, which from experience is par of the course in apartment living, even luxury units. 1) I can hear my neighbor opening/closing drawers and cabinets in the kitchen which is a shared wall with my bedroom. But only occasionally. 2) My upstairs neighbor is a heavy heel walker, which again, I only hear in the bedroom. 3) The courtyard is in the middle of the complex, so the sound is amplified and bounces off the walls of the complex, which gets a little much when there's a birthday or late-afternoon gathering. However, considering the noise complaints about SeaTac  air traffic that many Burien residents have, it's not awful. Also, my apartment is located above the BBQ, which can be mouth watering when someone is BBQ'ing; I want to go down with a plate in my hand.\n\nIn all, I've been impressed with complex. I know the staff will continue to make the Maverick an exceptional place to live, putting the comfort and convenience of respectful residents first.\n\nAnd apologies in advance to my downstairs neighbor when I accidentally drop stuff. Sorry.",
      "date": "2018-05-22",
      "title": ""
    },
    {
      "id": "custom_23017c39-c17d-4a00-b46d-2ad654211999",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "rating": "5.0",
      "name": "Ruth Do",
      "text": "The Maverick is the place to be! The staff are super friendly and down to earth. Kendra & Justine are awesome!!! They also work hard hosting family events for the residents. The Maintenance staff are responsive and wonderful!  I am really appreciative of everyone's hard work. My daughter absolutely loves it here. I have not lived at a place like this before. I love how I do not need to go outdoors to take out trash/recycling and get my mail. The Maverick has great amenities. If you are looking at a place to live in Burien, I highly recommend that you check out The Maverick.",
      "date": "2025-04-21",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_255fff9c-049c-4da4-9018-11b9006e1777",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d6cd9-fb3d-763e-8ce5-7d6aeff98573.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d6cd9-fb3d-763e-8ce5-7d6aeff98573",
        "storage_key": "property/6767906449164263/019d6cd9-fb3d-763e-8ce5-7d6aeff98573.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "The Maverick",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?id=pano-8894952&tour=63b30830a72972189bca5fb7"
    }
  ],
  "faqs": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa4b-8797-70e0-ba6c-0c794f0262f1",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-maverick",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263"
    },
    {
      "lead_collector_id": "0198aa4b-87fa-7340-83d5-c09c9b465d87",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-maverick",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263"
    },
    {
      "lead_collector_id": "0198aa4b-885d-769b-ba2c-ebe8b30d9644",
      "lead_source": "LANDING_PAGE",
      "name": "the-maverick",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "yoga-studio-apartments-burien-wa",
      "search_query": "yoga studio apartments Burien WA",
      "category": "Amenity",
      "h1_title": "Yoga Studio Apartments in Burien, WA",
      "h2_subtitle": "Discover luxury living with a dedicated yoga studio in Burien, WA. Enjoy modern amenities tailored for wellness enthusiasts.",
      "page_copy": "Welcome to The Maverick, where luxury meets convenience in Burien, WA. Our apartments offer the perfect balance of comfort and modern amenities, including a state-of-the-art yoga studio. Whether you're a seasoned yogi or just beginning, this dedicated space provides the tranquility and focus you need to elevate your practice.\n\nChoose from our selection of stylish studio, one, or two-bedroom apartments, all designed with your lifestyle in mind. Situated in the vibrant University District, The Maverick invites you to enjoy breathtaking mountain views and a variety of community amenities like a movie theater and outdoor grill area. Embrace a wellness-focused lifestyle and explore availability today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Yoga Studio Apartments in Burien, WA",
      "seo_description": "Find luxury apartments with a yoga studio in Burien, WA. Discover a wellness-focused lifestyle at The Maverick today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "apartments-with-mountain-views-king-county",
      "search_query": "apartments with mountain views King County",
      "category": "Amenity",
      "h1_title": "King County Apartments with Mountain Views",
      "h2_subtitle": "Enjoy breathtaking mountain views from our apartments in King County. Discover modern living with a picturesque backdrop at The Maverick.",
      "page_copy": "At The Maverick in Burien, WA, savor breathtaking mountain views from your home, nestled in the heart of King County. Our thoughtfully designed studio, one, and two-bedroom apartments provide a serene retreat from the bustling city life, allowing you to witness the beauty of the mountains from the comfort of your living space.\n\nOur community offers a wealth of amenities, ensuring you have everything needed for a modern lifestyle. Enjoy features like a controlled access entrance, a yoga studio, and lofted townhomes with direct entry access. Experience the perfect combination of luxury and nature at The Maverick, where mountain views are just the beginning of a beautiful living experience in King County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "King County Apartments with Mountain Views",
      "seo_description": "Explore The Maverick in King County, offering apartments with stunning mountain views and modern amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-movie-theater-burien",
      "search_query": "luxury apartments with movie theater Burien",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Movie Theater in Burien",
      "h2_subtitle": "Experience luxury living in Burien with exclusive amenities like a private movie theater. Indulge in high-class comfort at The Maverick.",
      "page_copy": "Discover the epitome of luxury living at The Maverick in Burien, where our residents enjoy exclusive amenities, including a private movie theater. Perfect for film buffs and casual viewers alike, our theater provides a cozy setting to catch the latest hits or enjoy a classic film night with friends.\n\nBeyond the silver screen, The Maverick offers a selection of chic studio, one, and two-bedroom apartments, each designed with modern aesthetics and function. In the vibrant University District, you'll also find a yoga studio, outdoor grill area, and more. Embrace a lifestyle of leisure and refinement by exploring the luxurious offerings at The Maverick today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Movie Theater in Burien",
      "seo_description": "Explore luxury living at The Maverick in Burien, featuring exclusive amenities, including a private movie theater. Contact us now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "outdoor-grill-area-apartments-university-district",
      "search_query": "outdoor grill area apartments University District",
      "category": "Amenity",
      "h1_title": "University District Apartments with Outdoor Grill",
      "h2_subtitle": "Enjoy stunning outdoor grill areas at residences in the University District. Relish in communal dining and picturesque surroundings at The Maverick.",
      "page_copy": "Located in the heart of the University District, The Maverick apartments offer more than just luxurious living spaces; they provide a vibrant community atmosphere with an exquisite outdoor grill area. Perfect for hosting BBQs or enjoying the fresh air, our grill area delivers both convenience and luxury right at your doorstep.\n\nChoose from a variety of floor plans, including stylish studio, one, or two-bedroom apartments, all curated for modern living. Our community also boasts a yoga studio and a private movie theater, offering plenty of activities right within your reach. Experience the seamless blend of relaxation and social engagement at The Maverick, and explore our University District location today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "University District Apartments with Outdoor Grill",
      "seo_description": "Find modern apartments with outdoor grill areas in the University District at The Maverick. Discover premium living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "controlled-access-apartments-near-burien-town-square",
      "search_query": "controlled access apartments near Burien Town Square",
      "category": "Amenity",
      "h1_title": "Controlled Access Apartments Near Burien Town Square",
      "h2_subtitle": "Experience peace of mind with controlled access living near Burien Town Square. Enjoy stylish and secure homes at The Maverick.",
      "page_copy": "The Maverick, located just a stone's throw from Burien Town Square, offers residents the reassurance of controlled access apartments. Our secure electronic entrance ensures you and your loved ones enjoy a safe living environment while still having quick access to the vibrant activities and shops of Burien Town Square.\n\nIn addition to security, our community features beautifully appointed studio, one, and two-bedroom apartments. Each home is designed with contemporary finishes, including quartz countertops and custom light fixtures. Furthermore, enjoy on-site amenities such as a yoga studio and a private movie theater, crafting the perfect blend of safety, convenience, and style in one unforgettable location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Controlled Access Apartments Near Burien Square",
      "seo_description": "Discover controlled access apartments near Burien Town Square at The Maverick. Live securely and stylishly. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-burien-wa-the-maverick",
      "search_query": "one bedroom apartments burien wa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Burien, WA",
      "h2_subtitle": "Discover spacious one-bedroom apartments in Burien, WA. The Maverick offers modern designs with exceptional amenities.",
      "page_copy": "Welcome to The Maverick, where our one-bedroom apartments in Burien, WA, set a new standard in modern living. Designed to maximize comfort and style, each unit features elegant quartz countertops, stylish custom light fixtures, and expansive windows showcasing panoramic mountain views.\n\nLocated in the thriving University District, The Maverick is more than just a place to live. Residents enjoy access to first-rate amenities including a yoga studio, outdoor grill area, and private movie theater. Discover the perfect blend of luxury and convenience in our vibrant community and make The Maverick your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Burien, WA",
      "seo_description": "Explore The Maverick's modern one-bedroom apartments in Burien, WA. Enjoy upscale living with chic designs and top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-king-county-maverick",
      "search_query": "two bedroom apartments king county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in King County",
      "h2_subtitle": "Find spacious two-bedroom apartments in King County at The Maverick. Experience luxury living with top-notch amenities.",
      "page_copy": "For those seeking two-bedroom apartments in King County, The Maverick offers sophisticated living spaces that cater to modern lifestyles. Each apartment features elegant upgrades like quartz countertops and custom light fixtures, providing a chic and comfortable living environment.\n\nLocated in the University District of Burien, our community includes exceptional amenities such as a yoga studio, an outdoor grill area, and a private movie theater, allowing residents to relax and entertain. Enjoy the convenience of being close to vibrant local attractions while residing in a peaceful and secure community. Explore The Maverick, where comfort meets style in every apartment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in King County",
      "seo_description": "Discover luxurious two-bedroom apartments in King County at The Maverick. Experience comfort and excellent amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "studio-apartments-98166-the-maverick",
      "search_query": "studio apartments 98166",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in 98166",
      "h2_subtitle": "Explore modern studio apartments in the 98166 area. The Maverick offers style and convenience in Burien.",
      "page_copy": "Nestled in the heart of Burien's 98166 area, The Maverick presents chic and efficient studio apartments perfect for the modern urban dweller. Each studio is thoughtfully designed with upscale finishes including quartz countertops and custom light fixtures, creating a warm and inviting atmosphere.\n\nLiving at The Maverick means embracing a lifestyle enriched with convenient amenities like our yoga studio and high-speed wifi in all common areas. The property's proximity to local shopping and dining in the vibrant University District enhances the daily living experience. Discover the beauty of studio living at The Maverick today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in 98166 - The Maverick",
      "seo_description": "Find modern studio apartments in the 98166 area at The Maverick in Burien. Enjoy stylish living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "apartments-near-highline-college-burien-the-maverick",
      "search_query": "apartments near highline college burien",
      "category": "School",
      "h1_title": "Apartments Near Highline College Burien",
      "h2_subtitle": "Discover convenient apartments near Highline College in Burien. The Maverick offers modern living close to campus.",
      "page_copy": "Situated just a short drive from Highline College in Burien, The Maverick provides an ideal living space for students and professionals alike. Our apartments offer a perfect blend of comfort and convenience, featuring stylish interiors with quartz countertops and designer light fixtures.\n\nAt The Maverick, residents can enjoy a variety of upscale amenities, including a yoga studio, outdoor grill area, and private movie theater, all within a vibrant community setting. Make the most of your academic or professional journey by choosing a home that supports your lifestyle. Experience the ease of access to Highline College and explore the surrounding neighborhood, full of dining and entertainment choices.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Highline College in Burien",
      "seo_description": "Find modern apartments near Highline College Burien at The Maverick. Enjoy comfortable living close to campus with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "the-maverick-apartments-near-south-seattle-college",
      "search_query": "the maverick apartments close to south seattle college",
      "category": "School",
      "h1_title": "The Maverick Near South Seattle College",
      "h2_subtitle": "Discover The Maverick Apartments close to South Seattle College. Experience modern amenities and a convenient location.",
      "page_copy": "The Maverick Apartments offer an exceptional living experience for those studying or working near South Seattle College. Just a short commute away, these contemporary apartments provide easy access to the campus while ensuring a comfortable lifestyle.\n\nResidents enjoy upscale features within each apartment, including quartz countertops and custom lighting, creating an elegant living space. The Maverick's community amenities, such as a yoga studio and movie theater, enhance relaxation and recreation. With close proximity to the vibrant University District, you will appreciate both the convenience and the community atmosphere at The Maverick.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Maverick Near South Seattle College",
      "seo_description": "Live at The Maverick, close to South Seattle College. Enjoy modern living and premium amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "apartments-near-valley-medical-center-burien-the-maverick",
      "search_query": "apartments near valley medical center burien",
      "category": "Hospital",
      "h1_title": "Apartments Near Valley Medical Center Burien",
      "h2_subtitle": "Explore modern apartments near Valley Medical Center in Burien. The Maverick offers an ideal location and amenities.",
      "page_copy": "The Maverick stands out as a premier choice for those seeking apartments near Valley Medical Center in Burien. With stylish studio, one, and two-bedroom options, our community provides both comfort and convenience just minutes from the medical center.\n\nEach apartment at The Maverick is designed with attention to detail, featuring upscale finishes like quartz countertops and designer lighting. Enjoy our range of on-site amenities, including a yoga studio, outdoor grill area, and reliable wifi in all common areas. The Maverick offers a perfect blend of serene living and easy access to essential facilities, making it an excellent choice near Valley Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Valley Medical Center Burien",
      "seo_description": "Discover The Maverick Apartments near Valley Medical Center in Burien. Enjoy a modern home with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "apartments-close-to-st-anne-hospital-98166-the-maverick",
      "search_query": "apartments close to st anne hospital 98166",
      "category": "Hospital",
      "h1_title": "Apartments Close to St. Anne Hospital 98166",
      "h2_subtitle": "Find apartments near St. Anne Hospital in the 98166 area. The Maverick offers convenience and top-notch amenities.",
      "page_copy": "Located in the heart of Burien's vibrant community, The Maverick provides ideal living spaces close to St. Anne Hospital in the 98166 zip code. Our modern apartments, available in studio, one, and two-bedroom layouts, prioritize comfort and style with features like quartz countertops and custom lighting.\n\nResidents at The Maverick benefit from exceptional amenities, including a yoga studio, outdoor grill area, and movie theater, perfect for relaxing after a day at the hospital. The controlled access and lofted townhomes enhance privacy and security, making The Maverick a sought-after residence for those working at or visiting St. Anne Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to St. Anne Hospital 98166",
      "seo_description": "The Maverick offers modern apartments close to St. Anne Hospital in Burien, 98166. Enjoy convenience and premium living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "apartments-near-lincoln-park-burien-the-maverick",
      "search_query": "apartments near Lincoln Park Burien",
      "category": "Park",
      "h1_title": "Apartments Near Lincoln Park Burien",
      "h2_subtitle": "Discover the convenience of living near Lincoln Park. The Maverick Apartments in Burien offer modern comfort and style.",
      "page_copy": "Situated close to the beautiful Lincoln Park, The Maverick in Burien is an ideal choice for those who appreciate nature and modern living. Our apartments provide quick access to this local gem, perfect for outdoor enthusiasts who enjoy scenic walks and picnics.\n\nAt The Maverick, residents can choose from thoughtfully designed studio, one, and two-bedroom floor plans. Each apartment boasts high-end finishes such as quartz countertops and custom light fixtures. The community features, including a yoga studio, movie theater, and outdoor grill area, enhance the vibrant living experience near Lincoln Park. Enjoy the perfect blend of urban convenience and natural beauty at The Maverick.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lincoln Park Burien",
      "seo_description": "Live close to Lincoln Park at The Maverick. Enjoy modern apartments with top-notch amenities in Burien.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "the-maverick-close-to-seahurst-park",
      "search_query": "The Maverick close to Seahurst Park",
      "category": "Park",
      "h1_title": "The Maverick Close to Seahurst Park",
      "h2_subtitle": "Experience life at The Maverick near Seahurst Park. Discover modern living surrounded by nature's beauty in Burien.",
      "page_copy": "The Maverick is an exceptional apartment community located just a short distance from the stunning Seahurst Park. Surrounded by nature, The Maverick offers residents the chance to enjoy nearby trails and waterfront access while residing in the comfort of modern living.\n\nOur apartments come in a variety of floor plans, including studio, one, and two-bedroom options, each featuring exquisite details like quartz countertops and modern light fixtures. Residents can enjoy a range of amenities such as a yoga studio, outdoor grill, and a movie theater. Choose The Maverick for a unique blend of lifestyle and natural beauty near Seahurst Park in Burien.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Maverick Close to Seahurst Park",
      "seo_description": "Discover The Maverick near Seahurst Park. Enjoy modern living and stunning natural surroundings in Burien.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "burien-apartments-by-angle-lake-park-the-maverick",
      "search_query": "Burien apartments by Angle Lake Park",
      "category": "Park",
      "h1_title": "Burien Apartments by Angle Lake Park",
      "h2_subtitle": "Explore The Maverick, premier apartments near Angle Lake Park. Enjoy modern amenities and convenient access in Burien.",
      "page_copy": "Discover The Maverick, a vibrant apartment community in Burien conveniently located near Angle Lake Park. Be close to this beautiful recreational area where you can enjoy water-based activities and scenic walks right in your neighborhood.\n\nOur modern apartments, offering studio, one, and two-bedroom layouts, are designed with your comfort in mind, featuring high-end finishes like quartz countertops and custom light fixtures. The Maverick also includes remarkable community amenities such as a yoga studio, outdoor grill area, and a movie theater, ensuring you find relaxation and recreation at home after exploring nearby Angle Lake Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Burien Apartments by Angle Lake Park",
      "seo_description": "Live at The Maverick, offering modern Burien apartments near Angle Lake Park with top amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "apartments-near-seattle-tacoma-airport-the-maverick",
      "search_query": "apartments near seattle–tacoma international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Seattle–Tacoma Airport",
      "h2_subtitle": "Find your home at The Maverick, conveniently located near Seattle–Tacoma Airport. Enjoy modern amenities and easy airport access.",
      "page_copy": "If you're seeking a home with quick access to Seattle–Tacoma International Airport, look no further than The Maverick. Our Burien apartments provide the perfect balance of proximity to the airport and modern living comforts, making travel convenient and hassle-free.\n\nThe Maverick offers a selection of studio, one, and two-bedroom apartments, each one detailed with features like quartz countertops and custom light fixtures. Immerse yourself in a community enriched with amenities such as a yoga studio, an outdoor grill area, and a movie theater—all while situated just a short commute from Seattle–Tacoma International Airport. Enjoy seamless living at The Maverick.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Seattle–Tacoma Airport",
      "seo_description": "The Maverick offers modern apartments near Seattle–Tacoma Airport with convenient access and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "burien-apartments-close-to-tukwila-international-blvd",
      "search_query": "burien apartments close to tukwila international boulevard",
      "category": "Transit",
      "h1_title": "Burien Apartments Close to Tukwila Blvd",
      "h2_subtitle": "Discover The Maverick, Burien's modern apartments near Tukwila International Boulevard. Enjoy ease and style in a prime location.",
      "page_copy": "Welcome to The Maverick, where modern living is just moments away from Tukwila International Boulevard. These Burien apartments offer residents not only stylish living spaces but also the convenience of proximity to a bustling transportation corridor and vibrant local amenities.\n\nChoose from our thoughtfully designed studio, one, and two-bedroom floor plans, all featuring exquisite finishes such as quartz countertops and custom lighting. At The Maverick, community amenities include a yoga studio, outdoor grill area, and a movie theater, creating a dynamic and comfortable living environment close to Tukwila International Boulevard. Make The Maverick your home and enjoy everything that Burien has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Burien Apartments Close to Tukwila Blvd",
      "seo_description": "Experience modern living at The Maverick, Burien apartments close to Tukwila International Blvd with easy access and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "apartment-communities-near-king-county-airport-maverick",
      "search_query": "apartment communities near king county international airport",
      "category": "Transit",
      "h1_title": "Apartment Communities Near King County Airport",
      "h2_subtitle": "The Maverick offers stylish living near King County International Airport. Ideal for frequent travelers seeking comfort and accessibility.",
      "page_copy": "Consider The Maverick in Burien if you're searching for apartment communities near King County International Airport. Located just a short drive from the airport, The Maverick blends modern style with optimal convenience, perfect for those wanting stress-free travel access combined with luxurious living.\n\nOur community features well-appointed studio, one, and two-bedroom apartments, showcasing high-end finishes like quartz countertops, adding a touch of elegance to your lifestyle. Residents can unwind in our yoga studio, entertain in the outdoor grill area, or enjoy movies in our private theater, all within an easy commute from King County International Airport. Make your move to The Maverick for accessible and exceptional apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Communities Near King County Airport",
      "seo_description": "The Maverick provides stylish apartment living near King County International Airport with convenient access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164263",
      "source": "generator",
      "page_item_url": "apartments-near-angle-lake-station-maverick",
      "search_query": "apartments near angle lake station",
      "category": "Transit",
      "h1_title": "Apartments Near Angle Lake Station",
      "h2_subtitle": "Live at The Maverick, where proximity to Angle Lake Station meets modern comfort. Perfect for commuters desiring quick transit access.",
      "page_copy": "Discover The Maverick in Burien, ideally located for those searching for apartments near Angle Lake Station. This prime location offers residents the ease of reaching public transit quickly, making daily commuting and exploring the Seattle area both simple and convenient.\n\nChoose from our range of modern studio, one, and two-bedroom apartments, each featuring beautiful quartz countertops and custom lighting. The Maverick community is complete with amenities like a yoga studio, an outdoor grill area, and a movie theater, providing residents with both style and convenience just steps from Angle Lake Station. Experience seamless city living at The Maverick.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and seating, overlooking a courtyard with green space.",
        "public_id": "019d0811-fba5-773e-8b5e-ee38dab6e9a1",
        "storage_key": "property/6767906449164263/019d0811-fba5-773e-8b5e-ee38dab6e9a1.webp",
        "width": 2000,
        "height": 1545
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Angle Lake Station",
      "seo_description": "The Maverick offers modern apartments near Angle Lake Station with quick transit access and exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4781"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9241077762"
    },
    {
      "ID": "custom_pay_rent_url",
      "type": "STRING",
      "value": "https://www.biltrewards.com/paywithbilt/login/phone"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KQQWMK4K"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"https://webchat.omni.cafe/conversations/fc3dd3a9-8df1-4225-ae23-d48dce6c9f41/app.js?property=fc3dd3a9-8df1-4225-ae23-d48dce6c9f41&propertyName=The+Maverick&channelUuid=c0a15feb-7c1c-11eb-8904-42010aa8d42b\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_id",
      "type": "STRING",
      "value": "5rxwjqnzv1e"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40201552159"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/5rxwjqnzv1e"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "877-684-9311"
    },
    {
      "ID": "custom_seattle_income_limits_url",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ikc4MHJZRmtKa1dGV0l0NEF2cXh6cGc9PSIsInZhbHVlIjoiNmgzdThHaXRrK3NtdFM4Z2NTZHRNUT09IiwibWFjIjoiNGEwZmQyYjIyNzc4OTcwYWM4NTBlZWQyYmZlMWQ1NWZmZjMzOWY2OTEwZjZlNjI3YzJjYmI1YTdjZmI1MTgxZCJ9"
    },
    {
      "ID": "custom_pillar_properties_guarantee",
      "type": "STRING",
      "value": "Who says there are no guarantees in life?     At Pillar Properties, we care and it shows. As a family-owned company with roots in the Puget Sound region spanning five generations, we do things our way. That means we are focused on delivering an ideal resident experience as measured by our own exacting standards.     Our team works diligently to ensure that the experience at our properties aligns with residents’ lifestyles, needs, and expectations. Resident satisfaction drives everything we do. We know that feeling supported is one of the most important hallmarks of home and that is why we offer our Quietly Awesome Guarantee.     We are so confident that you will love your new Pillar Properties apartment that we will waive the early termination penalties as defined in your lease if you are not satisfied and decide to leave within the first thirty days. It’s just that simple."
    },
    {
      "ID": "custom_seattle_income_qualified_blurb",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_pillar_properties_screening_criteria",
      "type": "STRING",
      "value": "https://multihubmedia.com/company/5767906449162415/019db50d-a882-714b-9bd7-79cfd977d40f.pdf"
    },
    {
      "ID": "custom_pillar_properties_guarantee_disclaimer",
      "type": "STRING",
      "value": "·  Guarantee applies to the first 30 days of occupancy only  ·  Notify the Property Manager in writing if you decide to move  ·  Any extra days will be charged if the apartment is not vacated after the initial 30 days"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "4781",
  "custom_repli_id": "9241077762",
  "custom_pay_rent_url": "https://www.biltrewards.com/paywithbilt/login/phone",
  "custom_google_gtm_id": "GTM-KQQWMK4K",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"https://webchat.omni.cafe/conversations/fc3dd3a9-8df1-4225-ae23-d48dce6c9f41/app.js?property=fc3dd3a9-8df1-4225-ae23-d48dce6c9f41&propertyName=The+Maverick&channelUuid=c0a15feb-7c1c-11eb-8904-42010aa8d42b\" defer></script>",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_id": "5rxwjqnzv1e",
  "custom_hubspot_company_id": "40201552159",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/5rxwjqnzv1e",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "877-684-9311",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ikc4MHJZRmtKa1dGV0l0NEF2cXh6cGc9PSIsInZhbHVlIjoiNmgzdThHaXRrK3NtdFM4Z2NTZHRNUT09IiwibWFjIjoiNGEwZmQyYjIyNzc4OTcwYWM4NTBlZWQyYmZlMWQ1NWZmZjMzOWY2OTEwZjZlNjI3YzJjYmI1YTdjZmI1MTgxZCJ9",
  "custom_pillar_properties_guarantee": "Who says there are no guarantees in life?     At Pillar Properties, we care and it shows. As a family-owned company with roots in the Puget Sound region spanning five generations, we do things our way. That means we are focused on delivering an ideal resident experience as measured by our own exacting standards.     Our team works diligently to ensure that the experience at our properties aligns with residents’ lifestyles, needs, and expectations. Resident satisfaction drives everything we do. We know that feeling supported is one of the most important hallmarks of home and that is why we offer our Quietly Awesome Guarantee.     We are so confident that you will love your new Pillar Properties apartment that we will waive the early termination penalties as defined in your lease if you are not satisfied and decide to leave within the first thirty days. It’s just that simple.",
  "custom_pillar_properties_screening_criteria": "https://multihubmedia.com/company/5767906449162415/019db50d-a882-714b-9bd7-79cfd977d40f.pdf",
  "custom_pillar_properties_guarantee_disclaimer": "·  Guarantee applies to the first 30 days of occupancy only  ·  Notify the Property Manager in writing if you decide to move  ·  Any extra days will be charged if the apartment is not vacated after the initial 30 days"
};

export const generatedAt = '2026-11-05T04:20:19.085Z';
